export const SUBSCRIBE_DOMAINS_CSV_LIMIT = 100;
export const SUBSCRIBE_DOMAINS_HINT_WIDTH = "auto";
